import React, { useEffect, useMemo } from "react";
import FieldRenderer from "../../Form/FieldRenderer";
// import { APICONSTANT } from "../utils/api/Config";

import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedIsd,
  setSelectedIsdCode,
  setSelectedNisd,
  setSelectedNisdCode,
  setSelectedFline,
  setSelectedFlineCode,
  setSelectedMediumCode,
  setSelectedMediumData,
} from "./store";
import { APICONSTANT } from "../../../utils/api/Config";
import { postFetchData } from "../../../utils/api/FetchData";
import ApplyAndReset from "../../ui/ApplyAndReset";
import { hasAnyData } from "../districtDetailsFilter/store";
import { RootState } from "../../../utils/store";
import { useParams } from "react-router-dom";

function StateDetails({ ...props }) {
  const districtSlice = useSelector((state) => state.district);
  const hasData = hasAnyData(districtSlice);

  //   if (hasData) {
  //   console.log("districtSlice---------", districtSlice);
  //   console.log("At least one field has data!");
  // } else {
  //   console.log("All fields are empty.");
  // }

  const dispatch = useDispatch();
  const stateDetailsSelector = useSelector(
    (state: RootState) => state?.stateDetails
  );
  const params = useParams();
  const mediumOptions = [
    { id: "0", name: "All" },
    { id: "R", name: "RTR" },
    { id: "S", name: "STR" },
    { id: "F", name: "FLINE" },
  ];

  const stateAndApiData = [
    [setSelectedIsd, setSelectedIsdCode],
    [setSelectedFline, setSelectedFlineCode],
    [setSelectedNisd, setSelectedNisdCode],
    [setSelectedMediumData, setSelectedMediumCode],
  ];

  const details = async (url: string, fun: any) => {
    let response;
    if (url == APICONSTANT.service_list) {
      response = await postFetchData(1, dispatch, url, {
        report_id: Number(params?.id),
      });
    } else {
      response = await postFetchData(1, dispatch, url);
    }
    if (response?.status === 1) {
      dispatch(fun([{ id: "0", name: "All" }, ...response?.data]));
    }
  };

  const fetchOptions = async (url: string, fun: any) => {
    details(url, fun);
  };

  const formConfig = useMemo(
    () => [
      {
        name: "fline_code",
        //  label: "Division",
        options: stateDetailsSelector?.fline_data || [],
        placeholder: "Mode",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.mode_list,
        setSelectedCode: setSelectedNisdCode,
        // isDisabled:
        //   stateDetailsSelector?.medium_code?.[0] == "S" ? true : false,
        onMenuOpen: (apiUrl: string, fun: any) => fetchOptions(apiUrl, setSelectedFline),

        // onMenuClose: (name, values, apiUrl, fun) =>
        //   stateDetailsHandleChange(name, values, apiUrl, setSelectedTaluk),
      },
      {
        name: "isd_code",
        //  label: "Region",
        options: stateDetailsSelector?.isd_data || [],
        placeholder: "Land Type",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.isd_list,
        setSelectedCode: setSelectedFlineCode,
        // onMenuOpen: fetchOptions,
        onMenuOpen: (apiUrl: string, fun: any) => fetchOptions(apiUrl, setSelectedIsd),
      },
      {
        name: "medium_code",
        //  label: "Division",
        options: mediumOptions || [],
        placeholder: "Source",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.service_list,
        setSelectedCode: setSelectedMediumCode,
        // onMenuClose: (name, values, apiUrl, fun) =>
        //   stateDetailsHandleChange(name, values, apiUrl, setSelectedTaluk),
      },
      {
        name: "nisd_code",
        //  label: "District",
        options: stateDetailsSelector?.nisd_data || [],
        placeholder: "Service",
        multiple: true,
        category: "dropDown",
        apiUrl: APICONSTANT.service_list,
        setSelectedCode: setSelectedIsdCode,
        // isDisabled:
        //   stateDetailsSelector?.medium_code?.[0] == "F" ? true : false,
        onMenuOpen: (apiUrl: string, fun: any) =>
          fetchOptions(apiUrl, setSelectedNisd),

        //   onMenuClose: (name, values, apiUrl, fun) =>
        //     stateDetailsHandleChange(name, values, apiUrl, setSelectedNisd),
      },
    ],
    [
      stateDetailsSelector?.isd_data,
      stateDetailsSelector?.nisd_data,
      stateDetailsSelector?.fline_data,
      stateDetailsSelector?.medium_data,
    ]
  );
  // if (isLoading) return <p>Loading...</p>;
  // if (error) return <p className="text-red-500">Failed to load districts</p>;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {formConfig.map((field, index) => (
        <div key={index} className="">
          <FieldRenderer field={field} />
        </div>
      ))}

      <ApplyAndReset
        renderAbleId={
          hasData
            ? props?.renderAbleId?.main_filterable
            : props?.renderAbleId?.secondary_filterable
        }
        stateAndApiData={stateAndApiData}
        props={props}
      />
    </div>
  );
}

export default StateDetails;
